import React from "react";
import { LazyLoadImage } from "react-lazy-load-image-component";
import { DateTimeToNormalDate } from "../../../../custom/DateTimeToNormalDate";
import { FaRegStar, FaStar, FaStarHalfAlt } from "react-icons/fa";

const StoreCards = ({ reviewData, dummy_user, loadMoreData, hasMore }) => {
  // Check if there are no reviews
  if (!reviewData || reviewData.length === 0) {
    return (
      <div className="flex flex-col items-center justify-center py-16 px-6 text-center min-h-[400px]">
        <div className="mb-6 text-gray-300">
          <svg
            className="w-24 h-24 mx-auto"
            fill="none"
            stroke="currentColor"
            viewBox="0 0 24 24"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              strokeLinecap="round"
              strokeLinejoin="round"
              strokeWidth={1.5}
              d="M7 8h10M7 12h4m1 8l-4-4H5a2 2 0 01-2-2V6a2 2 0 012-2h14a2 2 0 012 2v8a2 2 0 01-2 2h-3l-4 4z"
            />
          </svg>
        </div>

        <h3 className="text-2xl font-semibold text-gray-700 mb-3">
          No Reviews Yet
        </h3>

        <p className="text-gray-500 max-w-md mb-8">
          The customer has not reviewed any stores.
        </p>

        {/* <div className="flex items-center gap-1 text-yellow-400 mb-6">
          <FaStar className="text-2xl opacity-30" />
          <FaStar className="text-2xl opacity-30" />
          <FaStar className="text-2xl opacity-30" />
          <FaStar className="text-2xl opacity-30" />
          <FaStar className="text-2xl opacity-30" />
        </div> */}

        {/* Optional: call-to-action button if appropriate in your context */}
        {/* <button className="px-6 py-3 bg-blue-600 text-white rounded-lg hover:bg-blue-700 transition">
          Write a Review
        </button> */}
      </div>
    );
  }

  return (
    <div>
      {reviewData.map((item) => {
        // Fixed rating display logic
        const rating = Number(item?.rating) || 0;
        const fullStars = Math.floor(rating);
        const hasHalfStar = rating % 1 >= 0.5;
        const emptyStars = 5 - fullStars - (hasHalfStar ? 1 : 0);

        return (
          <div
            key={item.id || `${item.user?.first_name}-${item.updatedAt}`}
            className="flex gap-4 p-6 border-b border-gray-200 last:border-b-0"
          >
            <div className="flex-shrink-0 w-[80px]">
              <LazyLoadImage
                src={item?.user?.profile_image || dummy_user}
                alt="user avatar"
                effect="blur"
                wrapperProps={{
                  style: { transitionDelay: "0.5s" },
                }}
                className="h-20 w-20 rounded-full shadow-md object-cover"
              />
            </div>

            <div className="flex-1">
              <div className="flex justify-between items-start mb-2">
                <div>
                  <p className="font-semibold text-[var(--text-color3)] capitalize">
                    {item?.user?.first_name} {item?.user?.last_name}
                  </p>
                  <p className="text-sm text-gray-600 mt-0.5">
                    {item?.product_detail?.name || "Product"}
                  </p>
                </div>
                <p className="text-sm text-gray-500 whitespace-nowrap">
                  {DateTimeToNormalDate(item?.updatedAt)}
                </p>
              </div>

              <p className="text-gray-700 mt-2 leading-relaxed">
                {item?.review || "No review text provided"}
              </p>

              <div className="flex items-center mt-4">
                <div className="flex">
                  {[...Array(fullStars)].map((_, i) => (
                    <FaStar
                      key={`full-${i}`}
                      className="text-[var(--color--2)] text-xl"
                    />
                  ))}

                  {hasHalfStar && (
                    <FaStarHalfAlt
                      className="text-[var(--color--2)] text-xl"
                    />
                  )}

                  {[...Array(emptyStars)].map((_, i) => (
                    <FaRegStar
                      key={`empty-${i}`}
                      className="text-[var(--color--2)] text-xl"
                    />
                  ))}
                </div>

                <span className="ml-3 text-gray-600 font-medium">
                  {rating.toFixed(1)}
                </span>
              </div>
            </div>
          </div>
        );
      })}

      {hasMore && hasMore > reviewData.length && (
        <div className="p-6 text-center">
          <button
            onClick={loadMoreData}
            className="px-8 py-3 bg-white border border-gray-300 rounded-lg shadow-sm hover:bg-gray-50 transition font-medium"
          >
            Load More Reviews
          </button>
        </div>
      )}
    </div>
  );
};

export default StoreCards;